import { NgModule } from '@angular/core';
import { TableComponent } from './table.component';
import { SharedModule } from 'app/modules/shared/shared.module';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DateSelectorModule } from '../date-selector/date-selector.module';
import { AdvanceVectoringTableComponent } from './advance-vectoring-table/advance-vectoring-table.component';
import { BasicVectoringUserTableComponent } from './basic-vectoring-user-table/basic-vectoring-user-table.component';



@NgModule({
  declarations: [TableComponent, AdvanceVectoringTableComponent, BasicVectoringUserTableComponent],
  imports: [
    SharedModule,
    MatTableModule,
    MatPaginatorModule,
    MatDialogModule,
    MatCardModule,
    DateSelectorModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatTooltipModule
  ],
  exports: [TableComponent, AdvanceVectoringTableComponent],
  providers: [
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: [] },
  ]
})
export class TableModule { }
